import { styled } from 'linaria/react';

export const PointsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-50);
`;

export const PointsAndRankWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-25);
  padding: var(--space-225) var(--space-200) var(--space-225) var(--space-150);
  cursor: pointer;
  border-top-right-radius: 19px;
  border-bottom-right-radius: 19px;

  &:hover {
    div span {
      color: var(--secondary-black) !important;
    }

    svg path {
      fill: var(--control-hover-accent) !important;
    }
  }
`;
